import { render, staticRenderFns } from "./RegistryFormTab.vue?vue&type=template&id=75266622"
import script from "./RegistryFormTab.vue?vue&type=script&lang=js"
export * from "./RegistryFormTab.vue?vue&type=script&lang=js"
import style0 from "./RegistryFormTab.vue?vue&type=style&index=0&id=75266622&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports